// Rupees use Indian digit grouping (₹1,23,456) and drop the decimals when the
// amount is whole, which is how prices are normally written in India.
export const money = (amount, symbol = '₹') => {
  const n = Number(amount || 0);
  const isINR = symbol === '\u20b9';
  const hasFraction = Math.round(n * 100) % 100 !== 0;
  const digits = isINR && !hasFraction ? 0 : 2;
  return `${symbol}${n.toLocaleString(isINR ? 'en-IN' : 'en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
};

export const formatDate = (d, opts) =>
  new Date(d).toLocaleDateString('en-US', opts || { month: 'long', day: '2-digit', year: 'numeric' });

export const slugify = (s) =>
  String(s || '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const stripHtml = (h) => String(h || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();

export const truncate = (s, n = 160) => (s && s.length > n ? `${s.slice(0, n - 1).trim()}…` : s || '');

export const cls = (...a) => a.filter(Boolean).join(' ');

export const pct = (price, compare) => (compare > price ? Math.round(((compare - price) / compare) * 100) : 0);
